import { MenuItem } from "@app/types";
import { Images } from "@assets/images";

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const DEFAULT_MINUTES_SECONDS_FORMAT = "mm:ss";

export const DEFAULT_PAGE = 1;
export const DEFAULT_TOTAL_PAGES = 1;

export const ACCESS_TOKEN_KEY = "access_token";
export const USER_INFO_KEY = "user_info";
export const CURRENT_ACCOUNT = "current_account";

export const RECHARGE_COUNTDOWN_TIME = 15 * 60 * 1000; // 15 minutes, unit: ms

/** Số ký tự tối đa của ô nhập chữ, khớp với kiểm tra ở API (chặn dán chuỗi dài để spam) */
export const MAX_LEN = {
  /** mặc định cho mọi ô chữ (Input, TextArea, AuthField) */
  TEXT: 255,
  /** tên máy tự đặt: máy thuê, Cloud PC, Image Cloud, VPS */
  NAME: 32,
  FULL_NAME: 100,
  PHONE: 16,
  EMAIL: 100,
  ADDRESS: 255,
  NOTE: 255,
  SEARCH: 100,
  /** tên ngân hàng, số tài khoản, chủ tài khoản (rút tiền) */
  BANK: 100,
  /** username / password đăng nhập Play PCRender */
  CREDENTIAL: 64,
} as const;

export enum Role {
  ADMIN = "admin",
  USER = "user",
}

export enum PathnameUrl {
  GPU_HUB = "/",
  VPS_RENTAL = "/vps",
  PC_COMPONENT = "/pc-components",
  CLOUD_RENTAL = "/clouds",
  CREATE_CLOUD = "/create-clouds",
  RECHARGE = "/payment-history",
  IDENTITY_VERIFICATION = "/identity-verification",
  ORDER_MANAGEMENT = "/order-management",
  ORDER_VPS_MANAGEMENT = "/order-vps-management",
  LOG_MANAGEMENT = "/log-management",
  USER_GUIDE_MANAGEMENT = "/user-guide-management",
  ORDER_CLOUD_MANAGEMENT = "/order-cloud-management",
  ORDER_CLOUD_HISTORY = "/order-cloud-history",
  REF_CODE = "/ref-code",
  PROFILE = "/profile",
  CONFIRM_ACCOUNT = "/confirm-account",
  CHANGE_PASSWORD = "/change-password",
  EKYC = "/ekyc",
  EKYC_CONSENT = "/ekyc-consent",
  VERIFY_PHONE_CONSENT = "/verify-phone-consent",
  VERIFY_PHONE = "/verify-phone",
  INTRODUCE = "/introduce",
  CONTACT = "/contact",
  TERMS = "/term-of-service",
}

export enum LabelAdmin {
  GPU_HUB = "Thuê Máy Tính Vật Lý",
  PC_COMPONENT = "Thuê Linh Kiện Mang Về",
  DOWNLOAD_GAME = "Yêu Cầu Tải Game",
  VPS_RENTAL = "Thuê VPS",
  CLOUD_RENTAL = "Cloud Gaming - Render",
  RECHARGE = "Nạp tiền",
  IDENTITY_VERIFICATION = "Hợp Đồng Thuê Máy",
  ORDER_MANAGEMENT = "Quản lý đơn hàng",
  ORDER_VPS_MANAGEMENT = "Quản lý đơn hàng VPS",
  LOG_MANAGEMENT = "Quản lý Log",
  USER_GUIDE_MANAGEMENT = "Hướng Dẫn Sử Dụng",
  ORDER_CLOUD_MANAGEMENT = "Quản lý đơn hàng Cloud",
  REF_CODE = "Giới thiệu bạn bè",
  EKYC = "Xác minh danh tính",
}

export const MenuAdmin: readonly MenuItem[] = [
  {
    linkTo: PathnameUrl.REF_CODE,
    icon: Images.InviteUser.default,
    label: LabelAdmin.REF_CODE,
  },
  {
    linkTo: PathnameUrl.GPU_HUB,
    icon: Images.NvidiaIcon.default,
    label: LabelAdmin.GPU_HUB,
  },
  {
    linkTo: PathnameUrl.ORDER_MANAGEMENT,
    icon: Images.Clipboard.default,
    label: LabelAdmin.ORDER_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.CLOUD_RENTAL,
    icon: Images.Cloud.default,
    label: LabelAdmin.CLOUD_RENTAL,
  },
  {
    linkTo: PathnameUrl.ORDER_CLOUD_MANAGEMENT,
    icon: Images.OrderCloud.default,
    label: LabelAdmin.ORDER_CLOUD_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.VPS_RENTAL,
    icon: Images.Vps.default,
    label: LabelAdmin.VPS_RENTAL,
  },
  {
    linkTo: PathnameUrl.ORDER_VPS_MANAGEMENT,
    icon: Images.OrderVps.default,
    label: LabelAdmin.ORDER_VPS_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.RECHARGE,
    icon: Images.MoneyIcon.default,
    label: LabelAdmin.RECHARGE,
  },

  {
    linkTo: PathnameUrl.PC_COMPONENT,
    icon: Images.Hardware.default,
    label: LabelAdmin.PC_COMPONENT,
  },
  {
    linkTo:
      "https://docs.google.com/forms/d/1soWtWMAm3_SgN6oe0PCDeHdojvjYMuIeYGNTRKE0ZUo/preview",
    icon: Images.GameDownload.default,
    label: LabelAdmin.DOWNLOAD_GAME,
  },
  {
    linkTo: PathnameUrl.PROFILE,
    icon: Images.Ekyc.default,
    label: LabelAdmin.EKYC,
  },
  {
    linkTo: PathnameUrl.IDENTITY_VERIFICATION,
    icon: Images.IdentityCardIcon.default,
    label: LabelAdmin.IDENTITY_VERIFICATION,
  },
  {
    linkTo: PathnameUrl.LOG_MANAGEMENT,
    icon: Images.Log.default,
    label: LabelAdmin.LOG_MANAGEMENT,
  },
  {
    linkTo: PathnameUrl.USER_GUIDE_MANAGEMENT,
    icon: Images.UserGuide.default,
    label: LabelAdmin.USER_GUIDE_MANAGEMENT,
  },
];

export enum BootStatusCode {
  SUCCESS = 200,
  IMAGE_IS_OUT = 400,
  CANNOT_CREATE_RDP_FILE = 500,
}

export enum RechargeStatusCode {
  SUCCESS = 200,
  FAILED = 400,
}

export enum VerificationMethod {
  EMAIL = "email",
}
